'use client'

import Loader from 'components/Loader'
import FooterPortal from 'src/containers/Layouts/Layout/FooterPortal'
import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'src/store/modules/appConfig/selectors'

import CommunityPreviewItem from './CommunityPreviewItem'
import classes from './styles.module.scss'

const COMMUNITY_PREVIEWS_FROM_BUILDER = process.env.BINGO_COMMUNITY_PREVIEWS

export default function CommunityPreviewsPage() {
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const { builderData: communityPreviews, builderDataLoaded: communityPreviewsLoaded } = useBuilderCMSData(
    COMMUNITY_PREVIEWS_FROM_BUILDER,
  )
  if (!appInitialized) {
    return <Loader />
  }

  return (
    <>
      <div className={classes.container}>
        {communityPreviews.map((el) => {
          return <CommunityPreviewItem key={el.data.imageUrl} preview={el} />
        })}
      </div>
      {communityPreviewsLoaded && <FooterPortal />}
    </>
  )
}
